import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { PublisherForTableDTO } from './types'

export const PUBLISHER_FOR_TABLE_FRAGMENT: TypedDocumentNode<PublisherForTableDTO> = gql`
  fragment PublisherForTableFragment on User {
    email
    firstName
    id
    lastName
    role
    status
    updatedAt
    userWorkspaces {
      id
      name
      role
    }
  }
`
